import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import GlobalStoreContext from "../../../../context/GlobalStoreContext";
import Helper from "../../../../Helper";
import { Team } from "../../../../models/Team";
import TeamAvatar from "../../../Team/teamAvatar";
import { isGCOnJobsite, isTradeOnJobsite, isVendorOnJobsite } from "./helper";

interface Props {
    result: Team;
    extended: boolean;
}

const TeamResult: React.FC<Props> = (props) => {
    const context = React.useContext(GlobalStoreContext);

    const membershipStrings: string[] = [];
    const isGC = isGCOnJobsite(context, props.result);
    const isTrade = isTradeOnJobsite(context, props.result);
    const isVendor = isVendorOnJobsite(context, props.result);

    if (isGC) {
        membershipStrings.push("GC");
    }
    if (isTrade) {
        membershipStrings.push("Trade");
    }
    if (isVendor) {
        membershipStrings.push("Vendor");
    }

    const isOnJobsite = isGC || isTrade || isVendor;

    if (props.result.id === -1) {
        return <div className="font-bold">Create "{props.result.teamName}"</div>;
    }

    return (
        <div className="flex w-full flex-row items-center justify-between gap-4">
            <div className="flex flex-1 items-center gap-2">
                <TeamAvatar team={props.result} size={30} />
                {props.result.teamName}
            </div>
            {props.extended && (
                <>
                    <div className="flex-1 text-left">{Helper.addressFormater(props.result)}</div>
                    <div className="flex-1 text-left">{props.result.websiteUrl}</div>
                    {isOnJobsite && (
                        <div className="flex-1">
                            <div className="flex flex-row items-center gap-2 text-xs">
                                <FontAwesomeIcon icon={faCheckCircle} />
                                Already on Jobsite ({membershipStrings.join(", ")})
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default TeamResult;
